export default __webpack_public_path__ + "media/images/56-8a4457b21fa50d3a9b99b5d3ba6d907a.jpg";